/**
 * Mappe les codes d'erreur métier de la RPC delete_archived_crew
 * (portés par error.message côté Supabase, cf. useCrewActions.deleteCrew)
 * vers un message FR affichable. Partagé entre CrewDetailPage (fiche) et
 * CrewsListPage (liste) pour un message cohérent sur les deux surfaces
 * (revue 2026-05-31, finding #6). TICKET-CRM-07 / suppression équipage archivé.
 */
export function deleteCrewErrorMessage(err: unknown): string {
  const code = err instanceof Error ? err.message : '';
  switch (code) {
    case 'crew_delete_forbidden':
      return "Vous n'avez pas les droits pour supprimer un équipage.";
    case 'crew_has_paid_payments':
      return 'Cet équipage a des paiements encaissés : seul un superadmin peut le supprimer.';
    case 'crew_not_archived':
      return 'Seul un équipage archivé peut être supprimé.';
    case 'authentication_required':
      return 'Session expirée, veuillez vous reconnecter.';
    default:
      return 'Erreur lors de la suppression';
  }
}
